<form #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Integrações
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso nas integrações</small>
        </div>
        
        <ul class="list-group list-group-flush" *ngIf="entity">
            <ng-template [ngIf]="!isPerfilRepresentante">
                <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeImportarErp" name="podeImportarErp" id="podeImportarErp">
                        <label class="custom-control-label" for="podeImportarErp">Importar do ERP</label>
                    </div>
                    <p class="form-text text-muted">Selecione esta opção para permitir o usuário importar as informações do ERP, tais como, clientes, pedidos, notas fiscais, títulos a receber, etc.</p>
                </li>
                <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeImportarEcommerce" name="podeImportarEcommerce" id="podeImportarEcommerce">
                        <label class="custom-control-label" for="podeImportarEcommerce">Importar do E-commerce</label>
                    </div>                    
                    <p class="form-text text-muted">Selecione esta opção para permitir o usuário importar as informações do e-commerce, tais como, clientes e pedidos.</p>
                </li>
            </ng-template>
            
            <li class="list-group-item text-center" *ngIf="!possuiAlgumaOpcao()">
                <i class="fas fa-info" aria-hidden="true"></i> Nenhuma opção disponível
            </li>
        </ul>                               
    </div>
</form>